import React, {Dispatch, SetStateAction, useCallback} from 'react';

import {DateRangeInput} from 'src/components/input';

import ComboBox, {ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';


import {STATUS_DESCRIPTIONS} from '../../constants';

import type {UserEmailLogsCriteria} from '../../typedef';

type Props = {
    filter?: UserEmailLogsCriteria,
    onChange?: Dispatch<SetStateAction<UserEmailLogsCriteria>>,
};

export const StatusDateFilter = ({filter, onChange}: Props) => {
    const setStartDate = useCallback((date: string) => {
        if (onChange) {
            onChange(prev => ({...prev, startDate: date || undefined}));
        }
    }, [onChange]);

    const setEndDate = useCallback((date: string) => {
        if (onChange) {
            onChange(prev => ({...prev, endDate: date || undefined}));
        }
    }, [onChange]);

    const setStatus = useCallback((status: string) => {
        if (onChange) {
            if (status) {
                onChange(prev => ({...prev, status}));
            } else {
                onChange(prev => {
                    const {status: _status, ...rest} = prev;
                    return rest;
                });
            }
        }
    }, [onChange]);

    return (
        <Group direction="v" gap="s">
            <Label>Delivered Statuses</Label>
            <div style={{width: 270}}>
                <ComboBox value={filter?.status || ''} onChange={setStatus}>
                    <DefaultItem value="" key="all" caption="All Delivered Statuses"/>
                    {Object.entries(STATUS_DESCRIPTIONS).map(([key, {title}]) => (
                        <ComboboxItem key={key} value={key} caption={title}/>
                    ))}
                </ComboBox>
            </div>
            <Label>Period</Label>
            <DateRangeInput
                id="email-status-start-date-picker"
                width={270}
                label="Starts"
                clearable={true}
                startDate={filter?.startDate}
                endDate={filter?.endDate}
                preventFutureDate={true}
                selectRangeType="start"
                onChange={setStartDate}
            />
            <DateRangeInput
                id="email-status-end-date-picker"
                width={270}
                label={<>Ends&nbsp;&nbsp;</>}
                clearable={true}
                startDate={filter?.startDate}
                endDate={filter?.endDate}
                preventFutureDate={true}
                selectRangeType="end"
                onChange={setEndDate}
            />
        </Group>
    );
};
